import type { JSX } from 'react';
import styles from './TabsSelector.scss';

interface TabsSelectorProps {
  categories: string[];
  currentCategory: string;
  onCategorySelected: (category: string) => void;
  disabled: boolean;
  className: string;
  children?: JSX.Element[];
}

const TabsSelector = ({
  categories,
  currentCategory,
  onCategorySelected,
  children,
  disabled,
  className,
}: TabsSelectorProps) => {
  const resolveButtonStyle = (category: string) =>
    category === currentCategory ? `${styles.item} ${styles.selected}` : styles.item;

  const onCategoryClick = (category: string) => {
    if (category !== currentCategory && !disabled) {
      onCategorySelected(category);
    }
  };

  return (
    <div className={className}>
      <div className={styles.categorySelector}>
        {categories.map((category, index) => (
          <button
            type="button"
            className={resolveButtonStyle(category)}
            key={category}
            id={`payment-method-tab-${index}`}
            onClick={() => {
              onCategoryClick(category);
            }}
          >
            {children?.[index] || category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabsSelector;
